import { time, EntityEnvironment } from "@dinahmoe/dmafjs-core";

class WebAudioUtils extends EntityEnvironment {
  isSafari = this.#testSafari();
  isChrome = this.#testChrome();
  dbToJs = this.#dbToWAVolume;
  msToS = this.#dmafTimeToWebAudioTime;

  #dbToWAVolume(db) {
    return Math.floor(100 * Math.pow(2, db / 6)) / 100;
  }
  #dmafTimeToWebAudioTime(ms, offset) {
    return Math.max(0, (ms - offset) / 1000);
  }

  #testSafari() {
    return (
      navigator.vendor.match(/apple/i) &&
      !navigator.userAgent.match(/crios/i) &&
      !navigator.userAgent.match(/fxios/i)
    );
  }

  #testChrome() {
    return navigator.userAgent.includes("Chrome");
  }
}

const webAudioUtils = new WebAudioUtils("WebAudioUtils");
export { webAudioUtils, WebAudioUtils };
